export const apiKeyKeys = {
  me: ['apiKeys', 'me'] as const
};
